import React from 'react';
import { fmtCount } from '../../lib/format';
import { useDisplayMode } from '../../context/DisplayModeContext';
import { CELL_STYLE } from './DayCell';
export function WeekTotalCell({
  weekLabel,
  count,
  resultPct,
  resultMoney
}: {
  weekLabel: string;
  count: number;
  resultPct: number;
  resultMoney: number;
}) {
  const {
    formatResult
  } = useDisplayMode();
  const hasOps = count > 0;
  const pos = resultPct >= 0;
  const palette = !hasOps ? {
    background: '#ffffff',
    borderColor: '#eceef2',
    result: '#525866'
  } : pos ? {
    background: '#e3f6ea',
    borderColor: '#4ac78b',
    result: '#0fa95a'
  } : {
    background: '#ffe5e1',
    borderColor: '#ec8579',
    result: '#e94f43'
  };
  return <div style={{
    ...CELL_STYLE,
    background: palette.background,
    borderColor: palette.borderColor
  }} className="min-w-0" data-id="element-94" data-mp="1pklsrgyzgcu8">
      <span style={{
      position: 'absolute',
      top: 8,
      left: 9,
      fontSize: 12,
      fontWeight: 400,
      lineHeight: 1.2,
      color: '#525866'
    }} className="max-w-[70%] truncate" data-id="element-95" data-mp="3fymfinuwp0qf">
        {fmtCount(count)}
      </span>
      <span style={{
      position: 'absolute',
      top: 8,
      right: 9,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: 1.2,
      color: '#525866'
    }} className="tabular-nums" data-id="element-96" data-mp="61tvn5sbqs26">
        {weekLabel}
      </span>
      <span style={{
      position: 'absolute',
      left: 9,
      bottom: 9,
      fontSize: 15,
      fontWeight: 500,
      lineHeight: 1,
      color: palette.result
    }} className="tabular-nums" data-id="element-97" data-mp="fvj0rx8xr4ex">
        {formatResult({
        pct: resultPct,
        money: resultMoney
      })}
      </span>
    </div>;
}